import { jsx } from "react/jsx-runtime";
import Add from "@mui/icons-material/Add";
import { Tooltip } from "../Tooltip.js";
import { PlaceholderChip } from "./components/PlaceholderChip.js";
function Placeholder(props) {
  const { tooltip = "", swatchSize, ...rest } = props;
  return /* @__PURE__ */ jsx(Tooltip, { enterDelay: 500, placement: "bottom", title: tooltip, children: /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(PlaceholderChip, { size: swatchSize, ...rest, children: /* @__PURE__ */ jsx(Add, {}) }) }) });
}
export {
  Placeholder
};
//# sourceMappingURL=Placeholder.js.map
